import { render, staticRenderFns } from "./qyxxbgLook3.vue?vue&type=template&id=50fb389b&scoped=true&"
import script from "./qyxxbgLook3.vue?vue&type=script&lang=js&"
export * from "./qyxxbgLook3.vue?vue&type=script&lang=js&"
import style0 from "./qyxxbgLook3.vue?vue&type=style&index=0&id=50fb389b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fb389b",
  null
  
)

export default component.exports